<template>
  <div>
    <base-loading
      :show="loading"
      class="details-block py-3 my-3"
    />
    <div
      v-if="!loading"
      class="details-block"
      v-on="hoverHandlers"
    >
      <div class="mb-2 row px-2">
        <template v-if="editmode">
          <base-text
            size="s"
            class="col-6 p-0"
          >
            <base-texteditable
              ref="label"
              v-model="phone_number"
              class="phone-input"
              max-width="115px"
              :placeholder="`${phone_number && phone_number.length ? phone_number : 'Add phone'}`"
              @complete="updateCustomerInfo"
            />
          </base-text>
          <base-text
            size="s"
            class="col-6 p-0"
          >
            <div class="d-flex justify-content-end">
              <base-icon
                class="birth_date"
                icon="birthday"
              />
              <base-texteditable
                ref="label"
                v-model="birth_month"
                style="width:25px;"
                max-width="25px"
                class="birth_date-input"
                :placeholder="`${birth_month ? birth_month : 'MM'}`"
                @complete="updateCustomerInfo"
              />
              <span>/</span>
              <base-texteditable
                ref="label"
                v-model="birth_day"
                style="width:23px;"
                max-width="23px"
                class="birth_date-input"
                :placeholder="`${birth_day ? birth_day : 'DD'}`"
                @complete="updateCustomerInfo"
              />
              <span>/</span>
              <base-texteditable
                ref="label"
                v-model="birth_year"
                style="width:35px;"
                max-width="35px"
                class="birth_date-input"
                :placeholder="`${birth_year ? birth_year : 'YYYY'}`"
                @complete="updateCustomerInfo"
              />
            </div>
          </base-text>
        </template>
        <div
          v-else
          class="col-12 p-0 d-flex justify-content-between"
        >
          <base-text
            trim
            size="s"
            max-width="200px"
          >
            {{ phone_number && phone_number.length ? phone_number : 'No phone' }}
          </base-text>
          <div class="text-nowrap">
            <base-icon
              class="birth_date"
              icon="birthday"
            />
            <base-text
              nowrap
              size="s"
              class="mr-3"
            >
              <span v-if="details.birth_date">{{ details.birth_date | nicedate('small') }}</span>
              <span v-else>No birthday</span>
            </base-text>
          </div>
        </div>
      </div>
      <div class="last-active-label d-flex">
        <base-text class="last-active text-uppercase custom-label">
          LAST ACTIVE
        </base-text>
        <base-text muted>
          <span>{{ last_active ? last_active : '--' }}</span>
        </base-text>
      </div>
      <div class="last-active-label d-flex">
        <base-text class="last-active text-uppercase custom-label">
          BASED IN
        </base-text>
        <base-text
          muted
          max-width="150px"
        >
          <base-texteditable
            v-if="editmode"
            ref="label"
            v-model="location"
            class="based-in"
            max-width="150px"
            :placeholder="`${location ? location : 'Add location'}`"
            @complete="updateCustomerInfo"
          />
          <span v-else>{{ location ? location : '--' }}</span>
        </base-text>
      </div>
      <base-icon
        v-if="isHover && !editmode"
        class="details-block__edit"
        icon="pencil"
        @click="edit()"
      />
      <base-icon
        v-if="editmode"
        class="details-block__edit"
        icon="check"
        @click="updateCustomerInfo"
      />
    </div>
    <base-text class="mt-3 ml-1 custom-label last-active">
      GROUPS
    </base-text>
    <base-list :items="groups">
      <template v-slot:nodata>
        <empty
          class="mt-2"
          title="No groups for this client"
        />
      </template>
      <template v-slot:default="{item}">
        <base-cell v-slot:default="{hover}">
          <base-avatar
            :size="27"
            class="mx-3"
            :username="item.name"
          />
          <base-text size="m">
            {{ item.name }}
          </base-text>
          <base-button
            v-if="hover"
            class="rm-btn ml-auto p-0 text-muted"
            text
            @click="removeGroup(item.pk)"
          >
            Remove
          </base-button>
        </base-cell>
      </template>
    </base-list>
  </div>
</template>
<script>
import hoverable from '../../mixins/hoverable';

export default {
  name: 'Details',
  mixins: [hoverable],
  props: {
    details: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editmode: false,
      editablesItems: ['based in'],
      localItem: {},
      phone_number: null,
      location: null,

      birth_year: null,
      birth_month: null,
      birth_day: null,
    };
  },
  computed: {
    last_active() {
      if (!this.details.last_active) return null;
      return this.$options.filters.nicedate(this.details.last_active);
    },
    groups() {
      if (!this.details.member_of) {
        return [];
      }
      return this.details.member_of.filter((item) => !(item.is_supergroup));
    },
  },
  watch: {
    details(newval) {
      this.phone_number = newval.phone_number;
      this.setBirthdateInputs(newval.birth_date);
      this.location = newval.based_in;
    },
  },
  mounted() {
    this.phone_number = this.details.phone_number;
    this.location = this.details.based_in;
    // this.groups = this.details.member_of;
  },
  methods: {
    edit() {
      this.setBirthdateInputs(this.details.birth_date);
      this.editmode = true;
      this.$nextTick().then(() => {
        this.$refs.label.focus();
      });
    },
    updateCustomerInfo() {
      const data = {
        pk: this.$route.params.id,
        phone_number: this.phone_number,
        birth_date: this.buildBirthDateFromInputs(),
        location: this.location,
      };
      this.$emit('edited', data);
      this.editmode = false;
    },
    removeGroup(id) {
      this.$emit('group-deleted', id);
    },
    // Properly create new birthdate from inputs
    buildBirthDateFromInputs() {
      if ([this.birth_year, this.birth_month, this.birth_day].every(((value) => value === ''))) { return null; }
      if (!this.birth_year || !this.birth_month || !this.birth_day) return undefined;
      const newDate = new Date(this.birth_year, this.birth_month - 1, this.birth_day);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(newDate.getTime())) return undefined;
      return newDate;
    },
    // Convert details birth date to it's parts to be used in edit inputs.
    setBirthdateInputs(dateString) {
      if (!dateString || !dateString.length) {
        this.birth_month = null;
        this.birth_year = null;
        this.birth_day = null;
        return;
      }
      const dateObj = new Date(dateString);
      // eslint-disable-next-line no-unused-expressions
      this.birth_year = dateObj.getFullYear().toString();
      this.birth_month = (dateObj.getMonth() + 1).toString();
      this.birth_day = dateObj.getDate().toString();
    },
  },
};
</script>
<style lang="scss"
  scoped>
.details-block {
  background-color: $gray-light;
  border-radius: 3px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
  position: relative;

  .birth_date-input,
  .phone-input {
    font-size: 12px !important;
  }

  &::v-deep .base-text {
    // max-height: 14px !important;
    line-height: 14px;
  }

  &::v-deep img.birth_date {
    margin: 1px 7px 0px 0;
    float: left;
    text-align: right;
  }

  &::v-deep input.base-texteditable {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0;
    font-weight: 400 !important;
  }

  .based-in,
  .last-active-label {
    font-size: 11px;
    // height: 14px;
    line-height: 17px;

    span {
      font-size: 11px !important;
    }
  }

  &__edit {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
}

.last-active {
  font-size: 10px !important;
  line-height: 17px;
  height: 14px;
}

::v-deep .rm-btn {
  font-size: 11px !important;
}

.custom-label {
  color: #aaa;
  min-width: 75px;
}
</style>
